export const SCORM_PENDING_EVENTS_STORAGE_PREFIX = 'scorm_pending_events_';
